import styles from './index.module.scss';
import { Link } from 'react-router-dom';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Paths } from 'src/pages/paths';
import classNames from 'classnames';
import { useAdminHref } from '../helpers';

export type Mode = 'button' | 'link';

interface IProps {
  companyId: string;
  mode?: Mode;
}

export const LinkToCompanyInfo: FC<IProps> = ({ companyId, mode = 'link' }) => {
  const { t } = useTranslation();
  const href = useAdminHref(`${Paths.ADMIN_PAGE}${Paths.ADMIN_PAGE_COMPANY_INFO.replace(':companyId', companyId)}`);

  return (
    <Link to={href} className={classNames({ [styles.button]: mode === 'button', [styles.link]: mode === 'link' })}>
      {mode === 'button' && t('Common.showMore')}
      {mode === 'link' && companyId}
    </Link>
  );
};

export default LinkToCompanyInfo;
